export type MissingQuoteInfo = {
    quote_missing: true;
    message: string;
    first_available_date: string | null;
};

export const isMissingQuote = (value: unknown): value is MissingQuoteInfo => {
    return !!value && typeof value === "object" && (value as MissingQuoteInfo).quote_missing === true;
};

export const parseMissingQuoteBody = (body: unknown): MissingQuoteInfo | null => {
    if (!body || typeof body !== "object") {
        return null;
    }

    const data = body as {
        quote_missing?: boolean;
        message?: string;
        first_available_date?: string | null;
    };

    if (!data.quote_missing) {
        return null;
    }

    return {
        quote_missing: true,
        message: data.message ?? "Não encontramos cotação nesta data nem em dias anteriores.",
        first_available_date: data.first_available_date ?? null,
    };
};

export const formatFirstQuoteDate = (iso: string | null | undefined): string | null => {
    if (!iso) {
        return null;
    }

    const [year, month, day] = iso.split("-");
    if (!year || !month || !day) {
        return null;
    }

    return `${day}/${month}/${year}`;
};
